import React, { Component } from "react";
import Dropzone from "react-dropzone";
import axios from "axios";

class FileUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      file: null,
      response: null,
      uploading: false,
      progress: 0,
    };
  }

  onDrop = (files) => {
    this.setState({ file: files[0], uploading: true, progress: 0 });

    const formData = new FormData();
    formData.append("file", files[0]);

    const url = "https://files.umney.ru/upload";
    const fileName = files[0].name;
    const params = { file_name: fileName };

    axios
      .request({
        method: "post",
        url: url,
        params: params,
        data: files[0],
        onUploadProgress: (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100,
          );
          this.setState({ progress });
        },
      })
      .then((response) => response.data)
      .then(this.onUploadComplete)
      .catch((error) => console.log(error));
  };
  onCopy = async () => {
    const { response } = this.state;
    try {
      await navigator.clipboard.writeText(response.url);
      console.log("Content copied to clipboard");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };
  onUploadComplete = (data) => {
    this.setState({ response: data, uploading: false });
  };

  onReset = () => {
    this.setState({ file: null, response: null });
  };

  render() {
    const { file, response, uploading, progress } = this.state;

    return (
      <>
        {!response && !uploading && (
          <Dropzone onDrop={this.onDrop}>
            {({ getRootProps, getInputProps }) => (
              <div className="dropzone" {...getRootProps()}>
                <input {...getInputProps()} />
                Перетащите файл в данную область <br /> или кликните для выбора
                файла
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    style={{ height: "20vh", width: "20vw", fill: "#4080ff80" }}
                  >
                    <path d="M473.66 210c-14-10.38-31.2-18-49.36-22.11a16.11 16.11 0 01-12.19-12.22c-7.8-34.75-24.59-64.55-49.27-87.13C334.15 62.25 296.21 47.79 256 47.79c-35.35 0-68 11.08-94.37 32.05a150.07 150.07 0 00-42.06 53 16 16 0 01-11.31 8.87c-26.75 5.4-50.9 16.87-69.34 33.12C13.46 197.33 0 227.24 0 261.39c0 34.52 14.49 66 40.79 88.76 25.12 21.69 58.94 33.64 95.21 33.64h104V230.42l-36.69 36.69a16 16 0 01-23.16-.56c-5.8-6.37-5.24-16.3.85-22.39l63.69-63.68a16 16 0 0122.62 0L331 244.14c6.28 6.29 6.64 16.6.39 22.91a16 16 0 01-22.68.06L272 230.42v153.37h124c31.34 0 59.91-8.8 80.45-24.77 23.26-18.1 35.55-44 35.55-74.83 0-29.94-13.26-55.61-38.34-74.19zM240 448.21a16 16 0 1032 0v-64.42h-32z"></path>
                  </svg>
                </div>
              </div>
            )}
          </Dropzone>
        )}

        {uploading && (
          <div className="dropzone">
            <p>Загрузка файла: {file.name}</p>
            <div class="progress">
              <progress value={progress} max="100" />
              <div class="progress-value"></div>
              <div class="progress-bg">
                <div class="progress-bar"></div>
              </div>
            </div>
          </div>
        )}

        {response && (
          <div className="dropzone result">
            <p>
              Результат &nbsp;<span className="link">{response.url}</span>
              {/* <button
								className="icon_button"
								onClick={this.onCopy}
								title="Скопировать"
							>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
									<path d="M408 480H184a72 72 0 01-72-72V184a72 72 0 0172-72h224a72 72 0 0172 72v224a72 72 0 01-72 72z"></path>
									<path d="M160 80h235.88A72.12 72.12 0 00328 32H104a72 72 0 00-72 72v224a72.12 72.12 0 0048 67.88V160a80 80 0 0180-80z"></path>
								</svg>
							</button> */}
            </p>
            <button className="button" onClick={this.onReset}>
              Загрузить другой файл
            </button>
          </div>
        )}
      </>
    );
  }
}

export default FileUploader;
